import React, { useState, useEffect } from 'react';
    import { Link } from 'react-router-dom';
    import { motion } from 'framer-motion';
    import SafeIcon from '../common/SafeIcon';
    import * as FiIcons from 'react-icons/fi';
    import { initialBlogs } from '../data/blogs';

    const { FiCalendar, FiClock, FiArrowRight, FiSearch } = FiIcons;

    function BlogList() {
      const [searchTerm, setSearchTerm] = useState('');
      
      const filteredBlogs = initialBlogs.filter(blog =>
        blog.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        blog.category.toLowerCase().includes(searchTerm.toLowerCase())
      );

      return (
        <div className="bg-slate-50 min-h-screen pb-20">
          <div className="bg-indigo-600 text-white py-16 md:py-24">
            <div className="container mx-auto px-4 text-center">
              <motion.h1
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                className="text-4xl md:text-5xl font-black mb-4 uppercase tracking-tighter"
              >
                Design Insights & Stories
              </motion.h1>
              <div className="flex justify-center">
                <div className="bg-white/10 backdrop-blur-md px-6 py-2 rounded-full border border-white/20">
                  <span className="font-bold text-white">{initialBlogs.length}</span>
                  <span className="text-indigo-200 ml-2 uppercase text-xs tracking-widest">Total Stories</span>
                </div>
              </div>
            </div>
          </div>

          <div className="container mx-auto px-4 -mt-10">
            <div className="max-w-2xl mx-auto mb-12">
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-5 flex items-center pointer-events-none">
                  <SafeIcon icon={FiSearch} className="w-5 h-5 text-slate-400 group-focus-within:text-indigo-500 transition-colors" />
                </div>
                <input
                  type="text"
                  placeholder="Search by title or category..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-14 pr-6 py-5 bg-white border-none rounded-2xl shadow-xl shadow-slate-200/50 focus:ring-2 focus:ring-indigo-500 outline-none transition-all text-slate-700"
                />
              </div>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredBlogs.map((blog, idx) => (
                <motion.article
                  key={blog.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.05 }}
                  whileHover={{ y: -8 }}
                  className="bg-white rounded-[32px] overflow-hidden shadow-sm hover:shadow-2xl hover:shadow-indigo-500/10 transition-all border border-slate-100 group flex flex-col h-full"
                >
                  <Link to={`/blog/${blog.id}`} className="block relative aspect-[16/10] overflow-hidden">
                    <img src={blog.image} alt={blog.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                    <div className="absolute top-4 left-4">
                      <span className="bg-white/90 backdrop-blur-sm text-indigo-600 px-3 py-1 rounded-lg text-[10px] font-black uppercase tracking-widest shadow-sm">
                        {blog.category}
                      </span>
                    </div>
                  </Link>

                  <div className="p-8 flex flex-col flex-1">
                    <div className="flex items-center gap-4 text-slate-400 text-[11px] font-bold uppercase tracking-widest mb-4">
                      <div className="flex items-center gap-1.5">
                        <SafeIcon icon={FiCalendar} className="w-3.5 h-3.5" />
                        <span>{blog.date}</span>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <SafeIcon icon={FiClock} className="w-3.5 h-3.5" />
                        <span>{blog.readTime}</span>
                      </div>
                    </div>

                    <Link to={`/blog/${blog.id}`} className="block group-hover:text-indigo-600 transition-colors">
                      <h2 className="text-xl font-bold text-slate-900 mb-3 leading-tight line-clamp-2">
                        {blog.title}
                      </h2>
                    </Link>

                    <p className="text-slate-500 text-sm leading-relaxed mb-6 line-clamp-3">
                      {blog.excerpt}
                    </p>

                    <div className="mt-auto pt-6 border-t border-slate-50 flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-full bg-indigo-50 flex items-center justify-center text-indigo-600 font-bold text-xs">
                          {blog.author?.charAt(0) || 'A'}
                        </div>
                        <span className="text-xs font-bold text-slate-600">{blog.author}</span>
                      </div>
                      <Link to={`/blog/${blog.id}`} className="text-indigo-600 hover:text-indigo-700 transition-colors">
                        <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
                      </Link>
                    </div>
                  </div>
                </motion.article>
              ))}
            </div>
          </div>
        </div>
      );
    }

    export default BlogList;